module.exports = __webpack_public_path__ + "assets/icon_search.9717ad03.svg";